import type {AiPromptBox, AiPromptBoxReduxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {AiPromptBoxSendPhase, AiPromptBoxSize, PromptBoxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {getDefaultAttachments} from '@Components/ai-prompt-box/libraries/ai-prompt-box-attachment.library';

export const aiPromptBoxInitialState = (): AiPromptBoxReduxState => {
  return {};
};

export const isPromptBoxProcessing = (state: PromptBoxState): boolean => {
  return state === PromptBoxState.LOADING || state === PromptBoxState.STOPPABLE_LOADING;
};

export const getAiPromptBoxSendPhase = (state: AiPromptBox): AiPromptBoxSendPhase => {
  if (state.isFinishingUploads) {
    return AiPromptBoxSendPhase.SOFT_SENDING;
  }
  if (isPromptBoxProcessing(state.promptBoxState)) {
    return AiPromptBoxSendPhase.HARD_SENDING;
  }
  return AiPromptBoxSendPhase.IDLE;
};

export const isInAnySendPhase = (phase: AiPromptBoxSendPhase): boolean => {
  return phase !== AiPromptBoxSendPhase.IDLE;
};

export const hasActiveAttachmentLoaders = (attachmentLoaders?: AiPromptBox['attachmentLoaders']): boolean => {
  return !!attachmentLoaders && attachmentLoaders.length > 0;
};

export const getDefaultAiPromptBoxState = (isMobile: boolean = false): AiPromptBox => {
  return {
    prompt: '',
    placeholder: '',
    size: AiPromptBoxSize.MEDIUM,
    promptBoxState: PromptBoxState.IDLE,
    showInitialAnimation: true,
    attachments: getDefaultAttachments(),
    transcription: {
      showMic: false,
      permissionDenied: false,
      visualizerBarWidth: isMobile ? 2 : 3,
      visualizerGap: isMobile ? 3 : 2,
      visualizerFramesPerBar: isMobile ? 18 : 12,
    },
  };
};
